import {useTheme} from 'contexts/ThemeContext';
import React from 'react';
import {Text, TouchableOpacity, View} from 'react-native';
import strings from 'translations';
import styleSheet from './styles';

export interface ShareViewProps {
  onPressStopShare: () => void;
}

const ShareView = (props: ShareViewProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  return (
    <View style={styles.container}>
      <Text style={styles.leftText}>
        {strings.conferenceScreen.youAreScreenSharing}
      </Text>
      <TouchableOpacity onPress={props.onPressStopShare}>
        <Text style={styles.rightText}>
          {strings.conferenceScreen.stopShare}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

export default ShareView;
